<template>
  <div
    class="text-center text-h5 primary--text d-flex dashboard-text"
    :style="`min-height: ${minHeight}`"
  >
    {{ text }}
  </div>
</template>

<script>
export default {
  name: "DashboardText",
  props: {
    minHeight: {
      type: String,
      default: "58px",
    },
    text: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

<style scoped>
.dashboard-text {
  justify-content: center;
}
</style>
